"use client";

import { useState } from "react";
import Link from "next/link";
import useRtl from "@/hooks/useRtl";
import useDarkMode from "@/hooks/useDarkMode";
import useSkin from "@/hooks/useSkin";
import { ToastContainer } from "react-toastify";

import LogoLink from "@/components/home/LogoLink";
import DesktopNavLinks from "@/components/home/DesktopNavLinks";
import MobileMenuButton from "@/components/home/MobileMenuButton";
import MobileDrawer from "@/components/home/MobileDrawer";
import Footer from "@/components/home/Footer";
import { usePathname } from "next/navigation";
import { Toaster } from "@/components/ui/sonner";
import MobilePaymentReturn from "@/components/home/MobilePaymentReturn";

export default function HomeLayout({ children }) {
  const [isRtl] = useRtl();
  const [isDark] = useDarkMode();
  const [skin] = useSkin();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const path = usePathname();
  const isDiscoverAdminRoute = /^\/discover\/[^/]+\/admin(?:\/|$)/.test(path);

  // useEffect(() => {
  //   if (path !== '/') {
  //     return;
  //   }

  //   const hasVisited = localStorage.getItem('hasVisited');
  //   if (!hasVisited) {
  //     localStorage.setItem('hasVisited', 'true');
  //     router.push('/select');
  //   }
  // }, [router, path]);

  const handleDrawerToggle = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  return (
    <>
      <div
        dir={isRtl ? "rtl" : "ltr"}
        className={`app-wrap ${isDark ? "dark" : "light"} ${
          skin === "bordered" ? "skin--bordered" : "skin--default"
        }`}
      >
        {!isDiscoverAdminRoute && (
          <div className="bg-white py-3 sticky top-0 bg-inherit z-50 md:px-12 px-4">
            <div>
              <div className="hidden relative py-3 sm:flex flex-col justify-center">
                <LogoLink />
                <DesktopNavLinks />
              </div>
              <div className="sm:hidden relative flex items-center justify-between gap-2 my-1">
                <LogoLink />
                <div className="flex items-center gap-1">
                  <Link href="/discover/search" className="inline-flex min-h-[44px] items-center justify-center rounded-xl bg-[#0d6279] px-3 text-xs font-semibold text-white">
                    Find businesses
                  </Link>
                  <MobileMenuButton onClick={handleDrawerToggle} isOpen={isDrawerOpen} />
                </div>
                <MobileDrawer
                  isOpen={isDrawerOpen}
                  onClose={() => setIsDrawerOpen(false)}
                />
              </div>
            </div>
          </div>
        )}
        <ToastContainer />
        <MobilePaymentReturn />
        <div className="min-h-[76vh]">
          {children}
          <Toaster />
        </div>
        {!isDiscoverAdminRoute && <Footer />}
      </div>
    </>
  );
}
